import { render } from "./news_list.vue?vue&type=template&id=5b05201d&xmlns=http%3A%2F%2Fwww.w3.org%2F1999%2Fhtml"
import script from "./news_list.vue?vue&type=script&lang=js"
export * from "./news_list.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__